export enum JobState {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Started = 'Started',
}
